module.exports = __webpack_public_path__ + "static/media/heart.31cf1fb9.svg";